import { DEG_TO_RAD } from './constants';

export default function rad(degrees) {
    return degrees * DEG_TO_RAD;
}
